/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Snapshot } from "./Snapshot";
export const SnapshotResponse = core.serialization.object({
    data: Snapshot,
});
